var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { slot: "no-body" }, slot: "no-body" },
    [
      _vm.hasSeries
        ? _c("vue-apex-charts", {
            attrs: {
              id: "chart",
              type: "radialBar",
              width: "350",
              options: _vm.chartOptions,
              series: _vm.series,
            },
          })
        : _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "1rem",
                color: "#666",
              },
            },
            [_c("p", [_vm._v("No compliance data to display.")])]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }